import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { signOutApiCall } from "./authSlice";
import { toast } from "react-toastify";

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_BASE_URL_USERSERVICE}/masterCodes`,
  prepareHeaders: (headers, { getState }) => {
    headers.set("Access-Control-Allow-Origin", "*");
    const token = getState()?.auth?.userInfo?.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithAuth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    api.dispatch(signOutApiCall());
    toast.error(`Signed out successfully due to token expiration!`);
  }
  return result;
};

export const getFirmOnboardingValuesApi = createApi({
  reducerPath: "getFirmOnboardingValuesApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getssotype: builder.query({
      query: () => `SSO`,
    }),
    getemployeerangetype: builder.query({
      query: () => `EmployeeRange`,
    }),
    getknowustype: builder.query({
      query: () => `HowKnowUs`,
    }),
    getAllMasterCodes: builder.query({
      query: () => `/`,
    }),
  })
});

export const {
  useGetssotypeQuery,
  useGetemployeerangetypeQuery,
  useGetknowustypeQuery,
  useGetAllMasterCodesQuery
} = getFirmOnboardingValuesApi;
